export const environment = {
  AUTH0_DOMAIN: process.env.REACT_APP_AUTH0_DOMAIN!,
  // AUTH0_REDIRECT_URI is now dynamic (window.location.origin) - no longer needed here
  AUTH0_CLIENT_ID: process.env.REACT_APP_AUTH0_CLIENT_ID!,
  AUTH0_AUDIENCE: process.env.REACT_APP_AUTH0_AUDIENCE!,
  BASE_API_URL: process.env.REACT_APP_BASE_API_URL!,
  AGGRID_LICENCE_KEY: process.env.REACT_APP_AGGRID_LICENCE_KEY!,
  AMCHART_LICENCE_KEY: process.env.REACT_APP_AMCHART_LICENCE_KEY!,
  RECAPTCHA_KEY: process.env.REACT_APP_RECAPTCHA_KEY!,
  LIVECHAT_LICENSE_ID: process.env.REACT_APP_LIVECHAT_LICENSE_ID!,
  GA_KEY: process.env.REACT_APP_GA_KEY!,
  ENV: process.env.REACT_APP_ENVIRONMENT,
};
